var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclinePlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 12.1742V7.17422H18.475L23.475 12.1742H55ZM60 44.6742V19.6742C60 18.2992 58.875 17.1742 57.5 17.1742H42.5C41.125 17.1742 40 18.2992 40 19.6742V28.6992L45 33.6992V22.1742H55V39.6742H50.975L58.3 46.9992C59.275 46.6742 60 45.7742 60 44.6742ZM5.15 0.949219L1.625 4.47422L6.175 9.02422C5.45 9.87422 5 10.9742 5 12.1742V39.6742H0V47.1742H44.325L50.2 53.0492L53.725 49.5242L5.15 0.949219ZM10 39.6742V12.8492L36.825 39.6742H10Z",
    fill: "url(#paint0_linear_7171_616)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7171_616",
    x1: 0.461538,
    y1: 9.94831,
    x2: 22.5682,
    y2: 62.4568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000C9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclinePlan);
export default __webpack_public_path__ + "static/media/decline-plan.5a16d34f2fec7f3d602425eef8949df1.svg";
export { ForwardRef as ReactComponent };